module.exports = __webpack_public_path__ + "media/images/costumes/top/dress/thumbnail-8-84fa32e97b9e95a2ba9f44dadb47571f.jpg";